import { useTranslation } from 'react-i18next';
import type { ReactNode } from 'react';
import { Badge } from '@mantine/core';
import { IconCircleCheck, IconCircleDashed, IconHandStop, IconPencil, IconPlayerPause, IconProgress } from '@tabler/icons-react';
import type { SaleOrderStatus } from '@/types/sell';
import { STATUS } from '@/lib/statusColors';

interface SaleStatusBadgeProps {
  readonly status?: SaleOrderStatus;
}

// Статус оффера бейджем (иконка/цвет + текст, не только цвет — §9). В списке «Продам» живут
// ACTIVE и SUSPENDED; прочие статусы (модерация/сделка) подписываем нейтрально, не падая.
const VIEW: Partial<Record<SaleOrderStatus, { color: string; key: string; icon: ReactNode }>> = {
  ACTIVE: { color: STATUS.active, key: 'app.sell.status.active', icon: <IconCircleCheck size={12} /> },
  SUSPENDED: { color: STATUS.neutral, key: 'app.sell.status.suspended', icon: <IconPlayerPause size={12} /> },
  MODERATED: { color: STATUS.waiting, key: 'app.sell.status.moderated', icon: <IconHandStop size={12} /> },
  DRAFT: { color: STATUS.neutral, key: 'app.sell.status.draft', icon: <IconPencil size={12} /> },
  UNDER_BARGAIN: { color: STATUS.active, key: 'app.sell.status.underBargain', icon: <IconProgress size={12} /> },
};

export default function SaleStatusBadge({ status }: SaleStatusBadgeProps) {
  const { t } = useTranslation();
  if (!status) {
    return null;
  }
  const entry = VIEW[status];
  return (
    <Badge
      variant="light"
      color={entry?.color ?? 'gray'}
      tt="none"
      fw={500}
      radius="sm"
      // Неизвестный статус — нейтральный значок: часы сообщали бы «ждём», хотя о статусе ничего не известно.
      leftSection={entry?.icon ?? <IconCircleDashed size={12} />}
    >
      {entry ? t(entry.key) : status}
    </Badge>
  );
}
